/* Landing enzimas — JS extraido de enzimas-digestivas/index.html.
   Cargado por layout/landing.liquid (case 'enzimas'). */

/* ===== Formato COP ===== */
function cop(n){return '$'+n.toLocaleString('es-CO')}

/* ===== Bundles (1/2/3 frascos) ===== */
var BUNDLES=[
  {label:'1 Frasco',  total:79900,  full:79900,  per:'/ frasco'},
  {label:'2 Frascos', total:139900, full:159800, per:'/ paquete de 2'},
  {label:'3 Frascos', total:167900, full:239700, per:'/ paquete de 3'}
];
var curB=0;
function renderPrices(){
  var b=BUNDLES[curB];
  var old=document.getElementById('xsOneOld');
  if(b.full>b.total){old.style.display='inline';old.textContent=cop(b.full);}else{old.style.display='none';}
  document.getElementById('xsOnePrice').textContent=cop(b.total);
  document.getElementById('xsOnePer').textContent=b.per;
  document.getElementById('xsAtc').textContent='Agregar al carrito · '+cop(b.total);
  document.getElementById('xsStickyAtc').textContent='Agregar al carrito · '+cop(b.total);
}
document.querySelectorAll('#xsSizes .xs-size').forEach(function(s){
  s.addEventListener('click',function(){
    document.querySelectorAll('#xsSizes .xs-size').forEach(function(x){x.classList.remove('act')});
    s.classList.add('act');curB=+s.dataset.b;renderPrices();
  });
});
renderPrices();

/* ===== Announce rotativo ===== */
(function(){
  var msgs=["Desarrollado con doctores◊","Envío gratis en todos los pedidos","Garantía de devolución de 60 días"];
  var i=0,el=document.getElementById('xsAnnText');
  setInterval(function(){i=(i+1)%msgs.length;el.textContent=msgs[i];},3500);
})();

/* ===== Galería: thumbs → main ===== */
(function(){
  var main=document.getElementById('xsGalMain');
  var mainImg=main.querySelector('img.xs-gen');
  document.querySelectorAll('#xsThumbs .xs-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('#xsThumbs .xs-thumb').forEach(function(x){x.classList.remove('act')});
      t.classList.add('act');
      if(mainImg) mainImg.src=t.dataset.src;
    });
  });
})();

/* ===== Carousel de especialistas ===== */
(function(){
  var docs=[
    {q:'"Una fórmula digestiva tiene que ganarse su lugar en la evidencia — no en el empaque."',n:'Consejo Científico',m:'Gastroenterología — Panel médico de la marca',img:(window.ENZIMAS_ASSETS&&window.ENZIMAS_ASSETS['ad-assets/doctor-1.png']),b:'MD'},
    {q:'"La digestión no debería ser una apuesta: dosis declaradas en la etiqueta, o no sale al mercado."',n:'Consejo Científico',m:'Naturopatía — Panel médico de la marca',img:(window.ENZIMAS_ASSETS&&window.ENZIMAS_ASSETS['ad-assets/doctor-2.png']),b:'ND'},
    {q:'"Enzimas para la comida de hoy, probióticos y prebióticos para el intestino de mañana. Ese es el orden correcto."',n:'Consejo Científico',m:'Nutrición — Panel médico de la marca',img:(window.ENZIMAS_ASSETS&&window.ENZIMAS_ASSETS['ad-assets/doctor-3.png']),b:'PhD'},
    {q:'"Si una cepa no sobrevive el ácido del estómago, no cuenta. Por eso elegimos organismos de esporas."',n:'Consejo Científico',m:'Microbiología — Panel médico de la marca',img:(window.ENZIMAS_ASSETS&&window.ENZIMAS_ASSETS['ad-assets/doctor-4.png']),b:'PhD'}
  ];
  var i=0;
  function render(){
    var d=docs[i];
    document.getElementById('xsDocQuote').textContent=d.q;
    document.getElementById('xsDocSig').textContent=d.n;
    document.getElementById('xsDocMeta').textContent=d.m;
    document.getElementById('xsDocIdx').textContent=(i+1)+' / '+docs.length;
    document.getElementById('xsDocBadge').textContent=d.b;
    var ph=document.querySelector('#xsDocPhoto img.xs-gen'); if(ph) ph.src=d.img;
    document.querySelectorAll('#xsDocAvs .xs-doc-av').forEach(function(a,j){a.classList.toggle('act',j===i)});
  }
  document.getElementById('xsDocPrev').onclick=function(){i=(i-1+docs.length)%docs.length;render()};
  document.getElementById('xsDocNext').onclick=function(){i=(i+1)%docs.length;render()};
  document.querySelectorAll('#xsDocAvs .xs-doc-av').forEach(function(a){a.onclick=function(){i=+a.dataset.i;render()}});
  setInterval(function(){i=(i+1)%docs.length;render()},6000);
})();

/* ===== Reviews marquee: duplicar para loop infinito ===== */
(function(){
  var t=document.getElementById('xsRevTrack');
  t.innerHTML+=t.innerHTML;
})();


/* ============================================================
   Seleccion de bundle + trigger Releasit COD  (enzimas)
   Patron canonico (memory/project_bundles_as_variants):
   cada bundle = 1 variante real con precio POR UNIDAD; se manda la cantidad
   real en input[name="quantity"] (Releasit lo lee del DOM al disparar COD),
   asi precio_unitario x qty = total del bundle y el pedido lleva las unidades
   fisicas reales para Dropi.
   NO usar _rsiV2.setState como primer path: solo el click nativo del boton
   Releasit re-lee window.productData tras cambiar la variante.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  var selectedVariantId = null;
  var selectedQty = 1;

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) {
      i.value = variantId;
    });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function bundleQty(el) {
    var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
    if (!q) {
      var idx = parseInt(el.getAttribute('data-bundle-index'), 10);
      q = isNaN(idx) ? 1 : idx + 1;
    }
    return q || 1;
  }

  // Los tiers llevan variant-id + qty; los CTA solo llaman a TriggerCOD(this),
  // asi el selector sirve igual si el tier es <div> o <button>.
  var bundles = document.querySelectorAll('[data-bundle-variant-id][data-bundle-qty]');

  function selectBundle(el) {
    var id = el.getAttribute('data-bundle-variant-id');
    if (!id) return;
    selectedVariantId = id;
    selectedQty = bundleQty(el);
    setVariantOnAllForms(id, selectedQty);
  }

  bundles.forEach(function (el) {
    el.addEventListener('click', function () { selectBundle(el); });
  });

  // Init: el bundle marcado activo en el HTML (o el primero)
  (function initSelected() {
    var active = null;
    for (var i = 0; i < bundles.length; i++) {
      var c = bundles[i].className || '';
      if (/(^|\s)(act|sel|activo|on|selected)(\s|$)/.test(c)) { active = bundles[i]; break; }
    }
    if (!active) active = bundles[0];
    if (!active) return;
    selectedVariantId = active.getAttribute('data-bundle-variant-id');
    selectedQty = bundleQty(active);
    setVariantOnAllForms(selectedVariantId, selectedQty);
  })();

  window.enzimasTriggerCOD = function (btn) {
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || selectedQty;
    if (variantId) setVariantOnAllForms(variantId, qty);
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
